import { FormControl, FormErrorMessage, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { FieldError, FieldErrorsImpl, FieldValues, Merge, UseFormRegister } from 'react-hook-form';
import { RadioItem } from 'types/formElement';

interface Props {
    id: string;
    name: string;
    items: RadioItem[];
    selected: string | number;
    register: UseFormRegister<FieldValues>;
    onChange: (id: string) => void;
    direction?: 'row' | 'column';
    isRequired?: boolean;
    isInvalid?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | null;
    disabled?: boolean;
    flex?: number | string;
}

const RadioComponent: FC<Props> = ({
    id,
    name,
    items,
    selected,
    onChange,
    register,
    direction = 'row',
    isRequired = false,
    isInvalid = null,
    disabled = false,
    flex = 'auto',
}) => {
    const [error, setError] = useState('');

    useEffect(() => {
        if (isInvalid?.message) {
            setError(isInvalid.message as string);
        } else {
            setError('');
        }
    }, [isInvalid]);

    return (
        <Stack w="100%" flex={flex} direction={direction} spacing={direction === 'row' ? '30px' : '15px'}>
            <Text variant="input" w="auto" color="gray.600">
                {name}
            </Text>
            <FormControl isInvalid={isInvalid !== null}>
                <RadioGroup
                    w="100%"
                    defaultValue={selected.toString()}
                    value={selected.toString()}
                    isDisabled={disabled}
                >
                    <Stack flexWrap="wrap" rowGap="10px" spacing="30px" direction="row" color="gray.600">
                        {items.map((item) => {
                            return (
                                <Radio
                                    ringColor={'black'}
                                    key={item.id}
                                    checked={selected === item.id}
                                    value={item.id.toString()}
                                    {...register(id, {
                                        required: isRequired ? 'Seleziona un opzione per continuare' : false,
                                        onChange: (event: ChangeEvent<HTMLOptionElement>) => {
                                            if (event.target.value) {
                                                onChange(event.target.value);
                                            }
                                        },
                                    })}
                                    color="gray.600"
                                >
                                    {item.label}
                                </Radio>
                            );
                        })}
                    </Stack>
                </RadioGroup>
                <FormErrorMessage fontSize={12}>{error}</FormErrorMessage>
            </FormControl>
        </Stack>
    );
};

export default RadioComponent;
